import React from 'react';

import { Mobile } from 'components/Responsive';

import { EmptyContainer, EmptyInfo, EmptyImage, EmptyMessage, BackgroundImage, EmptyTitle, BgImage } from './styles';

export enum BackgroundTypes {
  Cloud,
  Mountain,
  SimpleCloud,
}

export interface Props {
  title?: string;
  description: string;
  image: string;
  backgroundImage?: string;
  grey?: boolean;
  paddingMessage?: number;
  background?: boolean;
  transparent?: boolean;
  compact?: boolean;
}

const EmptyList = ({
  title,
  description,
  image,
  backgroundImage,
  grey,
  paddingMessage,
  background,
  transparent,
  compact,
}: Props) => (
  <EmptyContainer compact={compact} transparent={transparent} grey={grey}>
    <EmptyInfo compact={compact}>
      <EmptyImage src={image} />
      {title && <EmptyTitle>{`${title}`}</EmptyTitle>}
      <EmptyMessage backgroundImage={background} padding={paddingMessage}>{`${description}`}</EmptyMessage>
    </EmptyInfo>
    <Mobile>{background && <BgImage />}</Mobile>
    <Mobile>{backgroundImage && <BackgroundImage src={backgroundImage} />}</Mobile>
  </EmptyContainer>
);

export default EmptyList;
